export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9948.35fddd73.jpg";